import React, {Component, Fragment} from 'react';
import ResponsiveTable from 'Components/ResponsiveTable';
import ClassNames from 'classnames';
import Checkbox from 'Components/Checkbox';
import TransportersTableHeader from 'Components/TransportersTableHeader';
import CreateGroupCard from 'Components/TransportersCard/CreateGroupCard';
import SubHeading from 'Components/SubHeading';


class TransportersList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText : "",
            selectedTransporters : [],
            isCreateGroupPopupShown: false
        }
        this.viewMode = props.viewMode;
    }
    createGroup = (name, branches)=> {
        this.props.createGroup(name, this.state.selectedTransporters, branches);
        this.hideCreateGroupPopup();
    }

    showCreateGroupPopup = ()=> {
        this.setState({
            isCreateGroupPopupShown: true
        })
    }
    hideCreateGroupPopup = ()=> {
        this.setState({
            isCreateGroupPopupShown: false
        })
        this.setState({
            selectedTransporters:[]
        });
    }
    modifiedGroupInfo = () => {
        this.props.editGroup(this.state.selectedTransporters);
        this.setState({ selectedTransporters: [] });
    }
    selectTransporter = (transporter)=> {
        const selectedTransporters = [...this.state.selectedTransporters];
        const id = transporter.id;
        const transporterIndex = selectedTransporters.findIndex((transporter)=> {
            return transporter.id === id;
        });
        if(transporterIndex > -1) {
            selectedTransporters.splice(transporterIndex, 1);
        } else {
            selectedTransporters.push(transporter);
        }
        this.setState({
            selectedTransporters
        });
    }
    selectAllTransporters = ()=> {
        const selectedTransporters = [...this.state.selectedTransporters];
        const { transporters } = this.props;
        this.setState({
            selectedTransporters: selectedTransporters.length === transporters.length?[]: transporters
        });
    }
    render() {
        const { 
            transporters, 
            transportersCount, 
            branchesList,
            offset,
            isMultimode,
            checkMutiMode,
            providerType,
            isExim
        } = this.props;
        const { selectedTransporters, isCreateGroupPopupShown } = this.state;
        return (
            <div className={ClassNames("br-5 pl-15 pr-15 pt-15 pb-15 pr wt-650", {
                        'box-shadow': !this.props.editingGroup,
                        'highlighted-box-shadow bg-selection-highlight': this.props.editingGroup
                    })}>
                    {isCreateGroupPopupShown && 
                        <CreateGroupCard createGroup={this.createGroup} onCancel={this.hideCreateGroupPopup} editingGroup={this.props.editingGroup}  branchesList={branchesList} providerType={providerType}/>
                    }
                    
                    <TransportersTableHeader 
                        offset={offset}
                        showCreateGroupPopup = {this.showCreateGroupPopup}
                        fetchTransporters={this.props.fetchTransporters}
                        transportersCount={100}
                        editGroup={this.modifiedGroupInfo}
                        editingGroup={this.props.editingGroup}  
                        branchIdList={this.props.branchIdList}
                        transporters={transporters}
                        header={this.props.header}
                        searchPlaceholder={this.props.header && `Search ${this.props.header}` || ''}
                        providerType={providerType}
                    />
                    {
                        <div className="flex flex-center">
                            <div className="flex mb-20 inBlock mr-40">
                                <Checkbox type="square" onCheck={() => checkMutiMode(false, false)} checked={!isMultimode && !isExim}/>
                                <SubHeading text="FTL" className=""/>
                            </div>
                            <div className="flex mb-20 inBlock mr-40">
                                <Checkbox type="square" onCheck={() => checkMutiMode(true, false)} checked={isMultimode && !isExim}/>
                                <SubHeading text="Multi Mode" className=""/>
                            </div>
                            <div className="flex mb-20 inBlock">
                                <Checkbox type="square" onCheck={() => checkMutiMode(false, true)} checked={isExim && !isMultimode}/>
                                <SubHeading text="Exim" className=""/>
                            </div>
                        </div>
                    }
                    {
                        (transporters || []).map((transporter, index)=> {
                            const id = transporter.id;
                            return(
                            <Fragment key={index}>
                                {index === 0 && <div className="flex flex-middle mb-20 ">
                                    <Checkbox checked={transporters.length === selectedTransporters.length } className="ml-10 wt-50" type="square" onCheck={this.selectAllTransporters}/>
                                    <div className="fBold fs-16 header-dark-color wt-150 pl-5">Name</div>
                                    <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Company</div>
                                    <div className="fBold fs-16 header-dark-color wt-150 pl-15">Branch</div>
                                </div>}
                                <div className="flex flex-middle border-top-light pt-25 pb-25 bg-hover-theme pr">
                                    <Checkbox className="ml-10 wt-50" type="square" onCheck={this.selectTransporter.bind(this, transporter)} checked={selectedTransporters.find((transporter)=>{return transporter.id === id;})}/>
                                    <div className="fs-14 table-text-color wt-150 pl-5">{transporter.name}</div>
                                    <div className="fs-14 table-text-color wt-150 pl-15">{transporter.companyName}</div>
                                    <div className="fs-14 table-text-color wt-150 pl-15">{transporter.branchName}</div>
                                </div>
                            </Fragment>
                            )
                        })
                    }
                {!(transporters && transporters.length > 0) && <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Tranporter has been added</div>}
            </div>
        )
    }
}

export default TransportersList;
